import type { ImgHTMLAttributes } from "react";

// mobile
import Switch from "../../assets/images/icon_saving/switch.svg";
import Saving from "../../assets/images/icon_saving/saving.svg";
import Reversal from "../../assets/images/icon_saving/reversal.svg";

// dekstop
import Total from "../../assets/images/icon_saving/total.svg";
import Totalround from "../../assets/images/icon_saving/total-round.svg";
import Transfer from "../../assets/images/icon_saving/transfer.svg";
import Transferround from "../../assets/images/icon_saving/transfer-round.svg";
import Saldo from "../../assets/images/icon_saving/saldo.svg";
import Saldoround from "../../assets/images/icon_saving/saldo-round.svg";
import Clipboard from "../../assets/images/icon_saving/clipboard.svg";
import Clipboardround from "../../assets/images/icon_saving/clipboard-round.svg";
import Desktopsaving from "../../assets/images/icon_saving/saving-desktop.svg";

type IconProps = ImgHTMLAttributes<HTMLImageElement>;

const createIcon = (src: string, alt: string) => (props: IconProps) => (
  <img src={src} alt={alt} loading="lazy" {...props} />
);

// mobile
export const SwitchIcon = createIcon(Switch, "Switch");
export const SavingIcon = createIcon(Saving, "Saving");
export const ReversalIcon = createIcon(Reversal, "Reversal");

// desktop
export const TotalIcon = createIcon(Total, "Total");
export const TotalroundIcon = createIcon(Totalround, "Total-round");
export const TransferIcon = createIcon(Transfer, "Transfer");
export const TransferroundIcon = createIcon(Transferround, "Transfer-round");
export const SaldoIcon = createIcon(Saldo, "Saldo");
export const SaldoroundIcon = createIcon(Saldoround, "Saldo-round");
export const ClipboardIcon = createIcon(Clipboard, "Clipboard");
export const ClipboardroundIcon = createIcon(Clipboardround, "Clipboard-round");
export const DesktopSavingIcon = createIcon(Desktopsaving, "Desktopsaving");
